import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import SydInput from '../../../../../../components/commonDesign/SydInput'

const NumberEditor = forwardRef(({ value, onChange, onBlur, disabled }, ref) => {
  return (
    <SydInput
      ref={ref}
      type='number'
      value={value ?? ''}
      onChange={(e) => {
        const numValue = e.target.value === '' ? null : Number(e.target.value)
        onChange(numValue)
      }}
      onBlur={onBlur}
      disabled={disabled}
    />
  )
})

NumberEditor.displayName = 'NumberEditor'

NumberEditor.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool
}

export default NumberEditor
